<template>
    <div
        class="w-full rounded-lg bg-white dark:bg-slate-800 px-4 py-5 shadow-lg dark:shadow-slate-900/50 flex flex-row flex-wrap mb-3 relative"
        v-if="account"
    >
        <div
            class="absolute -top-4 -right-4 rounded-full w-10 h-10 bg-green-100 flex items-center justify-center"
            v-if="cardComplete && !tooEarly"
        >
            <i class="fal fa-check text-lg text-green-800"></i>
        </div>

        <div
            class="absolute -top-4 -right-4 rounded-full w-10 h-10 bg-red-100 flex items-center justify-center"
            v-if="tooEarly"
        >
            <i class="fal fa-exclamation text-lg text-red-800"></i>
        </div>

        <div class="lg:w-[30%] mb-3 mx-auto">
            <img
                :src="`${cdnUrl}/${card.card_image.path}/_small/${card.card_image.file_name}`"
                class="w-36 lg:w-full"
            />
        </div>
        <div class="lg:w-[70%] lg:pl-8">
            <h4 class="font-semibold mb-3">
                {{ card.title }}
            </h4>
            <div class="grid grid-cols-1 gap-2 text-sm">
                <div class="col-span-1">
                    <strong>Date Opened:</strong>
                    {{ account.date_opened }}
                </div>
                <div class="col-span-1">
                    <strong>Minimum Spend Deadline:</strong>
                    {{ minimumSpendDeadline }}
                </div>
                <div class="col-span-1">
                    <strong>Minimum Spend Requirement:</strong>
                    <span v-if="account.welcome_bonus?.minimum_spend_amount">
                        ${{ account.welcome_bonus.minimum_spend_amount?.toLocaleString() }}
                    </span>
                </div>
                <div class="col-span-1">
                    <strong>Welcome Bonus Amount:</strong>
                    <span v-if="account.welcome_bonus?.bonus_amount">
                        {{ account.welcome_bonus.bonus_amount.toLocaleString() }}
                        Rapid Rewards Points
                    </span>
                    <span v-else>
                        Not specified
                    </span>
                </div>
            </div>
        </div>

        <div
            class="w-full rounded-md bg-red-50 p-4 mt-3"
            v-if="errors.length > 0"
        >
            <div class="flex">
                <div class="shrink-0">
                    <svg
                        class="h-5 w-5 text-red-400"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z"
                            clip-rule="evenodd"
                        />
                    </svg>
                </div>
                <div class="ml-3">
                    <h3 class="text-sm font-medium text-red-800">
                        There {{ errors.length === 1 ? 'is' : 'are' }}
                        {{ errors.length }} error{{
                            errors.length === 1 ? '' : 's'
                        }}
                        with your card
                    </h3>
                    <div class="mt-2 text-sm text-red-700">
                        <ul role="list" class="list-disc space-y-1 pl-5">
                            <li
                                v-for="(err, eIndex) in errors"
                                :key="`err-${eIndex}`"
                            >
                                {{ err.message }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useCompanionPassStore } from '@/store/companionpass';

export default {
    name: 'OpenCard',
    props: {
        card: {
            type: Object,
            default: null,
        },
        account: {
            type: Object,
            default: null,
        },
        tooEarly: {
            type: Boolean,
            default: false,
        },
    },
    components: {},
    data: () => ({}),
    computed: {
        ...mapState(useCompanionPassStore, []),
        minimumSpendDeadline() {
            const raw = this.account?.welcome_bonus?.minimum_spend_deadline;
            if (!raw) return '';
            // Backend serializes AccountWelcomeBonus.minimum_spend_deadline as
            // 'Y-m-d'; render it in the same m/d/Y format used by date_opened.
            const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(raw);
            return m ? `${m[2]}/${m[3]}/${m[1]}` : raw;
        },
        errors() {
            let errors = [];
            if (this.account) {
                const wb = this.account.welcome_bonus;
                if (!wb?.minimum_spend_amount) {
                    errors.push({
                        message: 'Please enter the minimum spend amount.',
                    });
                }

                if (!wb?.minimum_spend_deadline) {
                    errors.push({
                        message: 'Please enter the minimum spend deadline.',
                    });
                }

                if (!wb?.bonus_amount || wb.bonus_amount < 1) {
                    errors.push({
                        message: 'Please enter the welcome bonus amount.',
                    });
                }
            }

            return errors;
        },
        cardComplete() {
            return this.errors.length > 0 ? false : true;
        },
        cdnUrl() {
            return window.cdnUrl;
        },
    },
    methods: {
        ...mapActions(useCompanionPassStore, []),
    },
    mounted() {},
};
</script>
